import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useStoreActions, useStoreState  } from "../../store/data-store";
import ColourSwatch from "../colour-swatch/colour-swatch";
import { DataService } from "../../services/data-service";
import { ShoppingThread } from "../../data-models/shopping-thread";
import { MetersToSkeins } from "../../services/conversion";
import { PurchaseThread } from "../../data-models/purchase-thread";
import { Project } from "../../data-models/project";

const ShoppingPage = () => {

    const [threads, setThreads] = useState<ShoppingThread[]>([]);
    const [projects, setProjects] = useState<Project[]>([]);
    const [showAll, setAllFilter] = useState(true);
    const [showProject, setProjectFilter] = useState<boolean[]>([]);
    const [showProjectFiler, setShowProjectFilter] = useState(false);
    const setInventory = useStoreActions(state => state.setInventory);
    const user = useStoreState(store => store.user);

    const navigate = useNavigate();

    useEffect(() => {
        getShoppingList();
    }, []);

    async function getShoppingList() {
        const dataService = new DataService();
        const tokens = await dataService.getAccessToken(user);
        const list = await dataService.getShoppingList(user.id, tokens.accessToken, []);
        list.forEach(x => x.skeinsPurchased = 0);
        setThreads(list);
        const listOfProjects = await dataService.getProjects(user.id, tokens.accessToken);
        var flags : boolean[] = [];
        listOfProjects.forEach(p => flags.push(true) );
        setProjectFilter(flags);
        setProjects(listOfProjects);
    }


    const checkOut = () => {
        async function completeShopping() {
            const purchaseThreads = threads.map((t)=> {
                return {
                    colourNumber: t.colourNumber,
                    skeinsPurchased: t.skeinsPurchased
                } as PurchaseThread;
            })
            const dataService = new DataService();
            const tokens = await dataService.getAccessToken(user);
            await dataService.purchaseThreads(user.id, tokens.accessToken, purchaseThreads);

            const updatedInventory = await dataService.getInventory(user.id, tokens.accessToken);
            setInventory(updatedInventory);

            navigate("/inventory");
        }
        completeShopping();
    }

    const toggleFilter = () => {
        console.log("TOGGLE FILTER");
        setShowProjectFilter(!showProjectFiler);
    }

    const addSkein = (idx:number) => {
        var updatedThreads = threads.map((t,i) => {
            if( i === idx)
            {
                t.skeinsPurchased += 1;
            }
            return t;
        })
        setThreads(updatedThreads);
    }
    const minusSkein = (idx:number) => {
        var updatedThreads = threads.map((t,i) => {
            if( i === idx)
            {
                t.skeinsPurchased = Math.max(0, t.skeinsPurchased-1);
            }
            return t;
        })
        setThreads(updatedThreads);
    }

    const checkAll = () => {
        const newCheck = !showAll;
        console.log(newCheck);
        setAllFilter(newCheck);
        var newProjectChecks = [...showProject];
        for(let i = 0; i < newProjectChecks.length; i++){
            newProjectChecks[i] = newCheck;
        }
        
        console.log(newProjectChecks);
        setProjectFilter(newProjectChecks);
    }


    const checkProject = (idx:number) => {
        const newChecks = showProject.map((x,i) => {
            if( i === idx){
                return !x;
            }
            else {
                return x;
            }
        })
        setProjectFilter(newChecks);
        setAllFilter(false);
    }

    const applyFilter = () => {
        async function getFilteredShoppingList() {
            var filteredProjects: number[] = [];
            for(let i = 0; i < showProject.length; i++){
                if( showProject[i]){
                    filteredProjects.push(projects[i].id);
                }
            }
            const dataService = new DataService();
            const tokens = await dataService.getAccessToken(user);
            const list = await dataService.getShoppingList(user.id, tokens.accessToken, filteredProjects);
            list.forEach(x => x.skeinsPurchased = 0);
            setThreads(list);
        }
        getFilteredShoppingList();
        toggleFilter();
    }

    return (
        <div className="page-section">
            <div className="section-title">Shopping Page</div>
            <div className="data-section shopping-section">
                <div>
                    <label className="highlighted">Project Filter</label><FontAwesomeIcon icon={ showProjectFiler ? "chevron-up" : "chevron-down"} onClick={toggleFilter}/>
                    { showProjectFiler && 
                        <div className="project-filter">
                            <div>
                                <button className="small-button" onClick={applyFilter}>Apply</button>
                            </div>
                            <div>
                                <input type="checkbox" onChange={checkAll} checked={showAll}/><span>All</span>
                            </div>
                            {
                                projects.map((p, idx) => {
                                    return (
                                    <div>
                                        <input key={idx} onChange={() => checkProject(idx)} type="checkbox" checked={showProject[idx]} onClick={() => checkProject(idx)}/><span>{p.name}</span>
                                    </div>
                                    )
                                })
                            }
                        </div>
                    }
                </div>
                <div>
                    <table>
                        <thead>
                            <tr>
                                <th></th>
                                <th className='col-colour-number'>#</th>
                                <th className='col-meters'>Meters</th>
                                <th className='col-meters'>Skeins</th>
                                <th>$</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                threads.map((t, idx) => {
                                    return (
                                    <tr key={idx}>
                                        <td><ColourSwatch colourNumber={t.colourNumber} /></td>
                                        <td>{t.colourNumber}</td>
                                        <td>{t.metersRequired}</td>
                                        <td>{MetersToSkeins(t.metersRequired)}</td>
                                        <td><FontAwesomeIcon icon="minus" onClick={() => minusSkein(idx)} /><span className='skeins-purchased'>{t.skeinsPurchased}</span><FontAwesomeIcon icon="plus" onClick={() => addSkein(idx)} /></td>
                                    </tr>);
                                    })
                            }
                        </tbody>
                    </table>
                </div>
                <div className="action-section">
                    <button onClick={checkOut}>Checkout</button>
                </div>
            </div>
        </div>
    )
}
export default ShoppingPage;